<template>
    <b-row class="data-atual">
        <b-col class="text-right">
            Belo Horizonte, {{dataAtual}}.
        </b-col>
    </b-row >
</template>

<script>
import moment from 'moment';

export default {
    name: "DataAtual",
    data(){
        return {
             dataAtual:'',   
        }
    },
    mounted(){
        this.dataAtual =  moment().format('dddd, LL');     
    }
}
</script>

<style scoped>
    .data-atual{ 
        font-size: 0.83em;        
        color: gray;  
        padding-right: 1rem;
        padding-top: 0.3rem;
        padding-bottom: 0.3rem;        
    }
</style>
